import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import {
  startOfMonth,
  endOfMonth,
  format,
  differenceInDays,
  addDays,
  parse,
  isValid,
} from "date-fns";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useParams,
} from "react-router-dom";
import { it } from "date-fns/locale";

function ListPresenze(props) {
  const apiToken = useContext(TokenContext);
  const [presenzeList, setPresenzeList] = useState([]);
  const [presenze, setPresenze] = useState([]);
  const [primoAnnuncioNameUnico, setPrimoAnnuncioNameUnico] = useState("");
  const [isOpen, toggleModal] = useState(false);
  const [removablePresenza, setRemovablePresenza] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  const [subscriptionId, setSubscriptionId] = useState("");
  const [orePresenza, setOrePresenza] = useState("8");

  const [selectedCellData, setSelectedCellData] = useState({
    data: "",
    fiscalcode: "",
  });

  // Ottieni la data di inizio e fine del mese corrente
  const startDate = startOfMonth(new Date());
  const endDate = new Date();

  // Filtra le date uniche dalla lista di presenze

  const { paramId } = useParams();

  const annuncementDate = parse(
    presenzeList.annuncementData,
    "dd/MM/yyyy",
    new Date()
  );

  const minDate = new Date(annuncementDate);

  // Genera un array di date uniche da startDate a endDate
  const dateList = Array.from(
    { length: differenceInDays(endDate, minDate) + 1 },
    (_, index) => addDays(minDate, index)
  );

  const presenzePerMese = dateList.reduce((acc, data) => {
    const meseAnno = format(new Date(data), "MMMM yyyy", { locale: it });
    acc[meseAnno] = acc[meseAnno] || [];
    acc[meseAnno].push(data);
    return acc;
  }, {});

  /*
  const presenzePerMese = dateList.reduce((acc, presenza) => {
    const mese = format(new Date(presenza.annuncementData), "MMMM yyyy");
    acc[mese] = acc[mese] || [];
    acc[mese].push(presenza);
    return acc;
  }, {});*/

  //const uniqueUser = Array.from(new Set(presenze.map(p => ({ fullName: p.valore.fullName, subscriptionId: p.valore.subscriptionId }))));

  const uniqueUser = Array.from(
    new Set(
      presenze
        .map((p) => ({
          fullName: p.valore.fullName,
          subscriptionId: p.valore.subscriptionId,
        }))
        .map(JSON.stringify)
    )
  ).map(JSON.parse);

  useEffect(() => {
    setLoading(false);
    Repo.getPresenzeList(apiToken, null, paramId)
      .then((response) => {
        setPresenzeList(response.data);
        setPresenze(response.data.presenzeList);
        setPrimoAnnuncioNameUnico(response.data.annuncementName);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const handleSaveData = () => {
    selectedCellData;

    const presenza = {
      dataPresenza: selectedCellData.data,
      OreServizio: orePresenza,
      subscriptionId: selectedCellData.subscriptionId,
    };

    Repo.UpdPresenze(apiToken, presenza, paramId)
      .then((response) => {
        setPresenzeList(response.data);
        setPresenze(response.data.presenzeList);
        setPrimoAnnuncioNameUnico(response.data.annuncementName);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
    toggleModal(false);
  };

  const handleCellClick = (
    selectedDate,
    selectedFiscalCode,
    selectedSubscriptionId
  ) => {
    // Aggiorna lo stato con i dati della cella selezionata

    setSelectedCellData({
      data: selectedDate,
      fiscalcode: selectedFiscalCode,
      subscriptionId: selectedSubscriptionId,
    });

    // Apri la modal
    toggleModal(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAlertVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [isAlertVisible]);

  const pageSize = 1; // Imposta il numero desiderato di righe per pagina

  // Calcola il numero totale di pagine necessarie
  const totalMonths = Object.keys(presenzePerMese).length;
  const totalPages = Math.ceil(totalMonths / pageSize);

  // Mantieni uno stato per la pagina corrente
  const [currentPage, setCurrentPage] = useState(1);

  // Calcola gli indici di inizio e fine per la pagina corrente
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalMonths);

  return (
    <>
      <div>
        <div className="row">
          <div className="col-8">
            <h1>{primoAnnuncioNameUnico}</h1>
          </div>

          {/* Aggiungi i controlli per la navigazione tra le pagine */}
          <div className="col-4 justify-content-end">
            <span>{`pagina ${currentPage} di ${totalPages}`}</span>
            <button
              className="btn"
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Precedente
            </button>

            <button
              className="btn"
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Successiva
            </button>
          </div>
        </div>

        {!loading && <Loader></Loader>}

        {Object.entries(presenzePerMese)
          .slice(startIndex, endIndex) // Slicing per ottenere solo i dati della pagina corrente
          .map(([meseAnno, dateList]) => (
            <div key={meseAnno}>
              <h4>{meseAnno}</h4>
              <table className="table table-striped table-hover">
                {/* Intestazione della tabella */}
                <thead>
                  <tr>
                    <th>Giorno presenza</th>
                    {uniqueUser &&
                      uniqueUser.map((userData, index) => (
                        <th key={index} id={userData.subscriptionId}>
                          {userData.fullName}
                        </th>
                      ))}
                  </tr>
                </thead>
                {/* Corpo della tabella */}
                <tbody>
                  {dateList.map((data, index) => (
                    <tr key={index}>
                      <td style={{ width: "100px", padding: "0.25em" }}>
                        {format(data, "dd/MM/yyyy")}
                      </td>
                      {uniqueUser.map((userData, nameIndex) => {
                        const { fullName, subscriptionId } = userData;
                        const presenzaGiorno = presenze.find(
                          (p) =>
                            p.valore.fullName === fullName &&
                            p.presenzaDate === format(data, "dd/MM/yyyy")
                        );
                        const ore = presenzaGiorno
                          ? presenzaGiorno.valore.oreServizio
                          : 0;

                        return (
                          <td
                            title={fullName}
                            key={nameIndex}
                            style={{ padding: "0.25em" }}
                            onClick={() =>
                              handleCellClick(
                                format(data, "dd/MM/yyyy"),
                                fullName,
                                subscriptionId
                              )
                            }
                          >
                            {presenzaGiorno ? (
                              <span className="badge bg-success text-white">
                                Presente {ore}
                              </span>
                            ) : (
                              <b>-</b>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

        <ModalComponent
          toggleModal={toggleModal}
          isOpen={isOpen}
          header={"Dettagli della cella"}
          body={
            <>
              <p>Data: {selectedCellData.data}</p>
              <p>Utente: {selectedCellData.fiscalcode}</p>
              <label htmlFor="orePresenza">Ore Presenza:</label>
              <input
                type="number"
                id="orePresenza"
                value={orePresenza}
                onChange={(e) => setOrePresenza(e.target.value)}
              />
            </>
          }
          buttonConfirm="Salva"
          function={() => handleSaveData()}
        />

        {isAlertVisible && (
          <div
            className="alert alert-danger"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>
              La fascia ISEE selezionata è inclusa in un intervento in corso.
            </b>
          </div>
        )}
      </div>
    </>
  );
}

export default ListPresenze;
